import set from 'lodash/set';
import get from 'lodash/get';
import moment from 'moment';
import {
  OPERATOR,
  WAREHOUSE,
  IN_POSSESSION,
  CHARGING,
} from '../lib/utils';
import {
  FETCH_ALL_VEHICLES,
  FETCH_MARKET_VEHICLES,
  FETCH_VEHICLE_TRIPS_BY_ID,
  VEHICLES_LOADING,
  VEHICLES_LOST_LOADING,
  CLEAR_MARKET_VEHICLES,
  FETCH_MARKET_LOST_DECOMMISSIONED_VEHICLES,
  FETCH_VEHICLE_ACTIVITIES,
  FETCH_VEHICLE_HISTORY,
} from '../actions/vehicles';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_VEHICLES:
      return {
        ...state,
        vehicles: action.payload,
      };
    case FETCH_MARKET_VEHICLES: {
      const marketVehicles = action.payload || [];
      const currentDate = moment();
      const deployableVehicles = marketVehicles.filter((vehicle) => (
        vehicle.extStatus === OPERATOR || vehicle.extStatus === CHARGING
      )
        && vehicle.extDeploymentStatus === WAREHOUSE
        && vehicle.extPossessionStatus === IN_POSSESSION
        && vehicle.batteryLevel >= 80
        && moment(vehicle.geoUpdatedAt).diff(currentDate, 'hours') <= 6
        && vehicle.geo !== null
        && vehicle.needsMaintenance === false);
      return {
        ...state,
        marketVehicles,
        allMarketVehicles: [...action.payload, ...get(state, 'marketLostDeletedVehicles', [])],
        deployableVehicles,
      };
    }
    case FETCH_MARKET_LOST_DECOMMISSIONED_VEHICLES:
      return {
        ...state,
        marketLostDeletedVehicles: action.payload,
        allMarketVehicles: [...action.payload, ...get(state, 'marketVehicles', [])],
      };
    case CLEAR_MARKET_VEHICLES:
      return {
        ...state,
        marketVehicles: undefined,
        allMarketVehicles: [...get(state, 'marketLostDeletedVehicles', [])],
      };
    case FETCH_VEHICLE_TRIPS_BY_ID: {
      const newState = { ...state };
      set(newState, `byId.${get(action, 'payload[0].vehicleId')}`, action.payload);
      return newState;
    }
    case FETCH_VEHICLE_ACTIVITIES: {
      const marketId = get(action, 'payload.marketId');
      let activities = get(state, 'activities', {});
      activities = {
        ...activities,
        [marketId]: get(action, 'payload.vehicles'),
      };
      return {
        ...state,
        activities,
      };
    }
    case FETCH_VEHICLE_HISTORY: {
      return {
        ...state,
        currentVehicleHistory: action.payload,
      };
    }
    case VEHICLES_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case VEHICLES_LOST_LOADING:
      return {
        ...state,
        isLostLoading: action.payload,
      };
    default:
      return state;
  }
}
